// extracted by mini-css-extract-plugin
module.exports = {"form":"paymentForm_form__2TFB4"};